import React from 'react';
import { useSelector } from 'react-redux';
import useSelectHandleLogout from '~/components/AccountGetsMarried/components/Header/hooks/useSelectHandleLogout';
import AccountDrawer from '~/components/HeaderV2/components/AccountDrawer';
import useToggleRuntimeVariable from '~/hooks/runtime/useToggleRuntimeVariable';
import useInitialWidth from '~/hooks/useInitialWidth';
import useSelectActiveUserProfile from '~/hooks/useSelectActiveUserProfile';

const ConnectedAccountDrawer = () => {
  const userProfile = useSelectActiveUserProfile();
  const [accountDrawerOpen, toggleAccountDrawerOpen] = useToggleRuntimeVariable('account-drawer');
  const initialWidth = useInitialWidth();

  return (
    <AccountDrawer
      accountSummary={useSelector((state: any) => state.account.summary)}
      anchorPosition={initialWidth === 'xs' ? 'left' : 'right'}
      currentProfile={userProfile}
      handleLogout={useSelectHandleLogout(toggleAccountDrawerOpen)}
      isAccountDrawerOpen={accountDrawerOpen}
      onClose={toggleAccountDrawerOpen}
    />
  );
};

export default ConnectedAccountDrawer;
